import {CopilotAnimation, CopilotAnimationType} from '@github-ui/copilot-animation'
import {Heading, Label, Link, Stack, useResponsiveValue} from '@primer/react'
import {DashboardFeedbackDialog} from '@github-ui/dashboard-feedback-dialog'
import styles from './CopilotHeaderBase.module.css'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export interface CopilotHeaderBaseProps {
  message: string
  animationType?: CopilotAnimationType
  loopAnimation?: boolean
  feedbackSubject?: string
  feedbackDialogEnabled?: boolean
  /**
   * When true, hides the Copilot animation logo from the header.
   */
  hideLogo?: boolean
  onToggleFeaturePreview?: () => void
}

export default function CopilotHeaderBase({
  message,
  animationType = 'static',
  loopAnimation = false,
  feedbackSubject,
  feedbackDialogEnabled = false,
  hideLogo = false,
  onToggleFeaturePreview,
}: CopilotHeaderBaseProps) {
  const logoSize = useResponsiveValue({regular: 36, narrow: 33}, 36) as number
  const showOptOutLink = isFeatureEnabled('dashboard_opt_in_opt_out_links')

  return (
    <div className={styles.greetingContainer}>
      <Stack direction="horizontal" align="start" gap="condensed">
        {!hideLogo && (
          <CopilotAnimation
            className={styles.copilotLogo}
            animationType={animationType}
            loopAnimation={loopAnimation}
            size={logoSize}
          />
        )}
        <Heading as="h2" className="h2">
          {message}
        </Heading>
      </Stack>
      <Stack direction="horizontal" align="center" gap="none">
        <span className="mr-1">
          <Label variant="success">Preview</Label>
        </span>
        {feedbackDialogEnabled ? (
          <span>
            &middot;{' '}
            <DashboardFeedbackDialog
              subject={feedbackSubject}
              placeholderText="Tell us your feedback on the new dashboard experience"
            />
            {onToggleFeaturePreview && showOptOutLink ? (
              <span>
                &nbsp;&middot;
                <Link
                  as="button"
                  onClick={onToggleFeaturePreview}
                  className={styles.toggleButton}
                  aria-label="Switch back to previous dashboard experience"
                >
                  Switch back
                </Link>
              </span>
            ) : null}
          </span>
        ) : null}
      </Stack>
    </div>
  )
}
